import React, { useEffect, useState } from "react";
import { ChevronDown, ChevronRight, Workflow } from "lucide-react";
import { SecondWBSAPI } from "../services/api";

/* interface TreeNode {
  text: string;
  tag: number;
  color: string;
  children: TreeNode[];
  wbsNo?: number;
  front?: number;
} */
interface TreeNode {
  text: string;
  tag: number;
  color: string;
  children: TreeNode[];

  wbsNo?: number;
  notationNo?: number;
  notationHead?: number;

  front?: number;
}

interface Props {
  projectId: number;
  refresh?: number;
  onSelect?: (node: TreeNode) => void;
}

const getNodeKey = (node: TreeNode) => {
  if (node.tag === 0) {
    return "root";
  }

  if (node.tag > 0) {
    return `wbs-${node.wbsNo ?? node.tag}`;
  }

  return `not-${node.notationNo ?? Math.abs(node.tag)}`;
};

/* const AccordionNode = ({
  node,
  level = 0,
  onSelect,
  selectedTag,
} */
const AccordionNode = ({
  node,
  level = 0,
  onSelect,
  selectedTag,
  openNodes,
  setOpenNodes,
}
: {
  node: TreeNode;
  level?: number;
  onSelect?: (node: TreeNode) => void;
  selectedTag: number | null;


    openNodes: Record<string, boolean>;

  setOpenNodes: React.Dispatch<
    React.SetStateAction<Record<string, boolean>>
  >;
  }) => {
  //const [open, setOpen] = useState(level === 0);
  const nodeKey = getNodeKey(node);

const open = openNodes[nodeKey] ?? (level === 0);

  const hasChildren = node.children?.length > 0;
  const isSelected = selectedTag === node.tag;
  const isNotation = node.tag < 0;

  return (
    <div>
      <div
        className={`group relative flex items-center px-2 py-1 rounded-md ${
          isSelected
            ? "bg-indigo-100 text-indigo-700 "
            : "hover:bg-indigo-50"
        }`}
        style={{ paddingLeft: `${level * 10}px` }}
      >
        {hasChildren ? (
          <button
            onClick={(e) => {
              e.stopPropagation();
             // setOpen((prev) => !prev);
             /* setOpenNodes((prev) => ({
  ...prev,
  [nodeKey]: !prev[nodeKey],
})); */
setOpenNodes((prev) => {

  const updated = {
    ...prev,
    [nodeKey]: !prev[nodeKey],
  };

  sessionStorage.setItem(
    "SecondWBSOpenNodes",
    JSON.stringify(updated)
  );

  return updated;
});
            }}
            className="w-4 h-4 flex items-center justify-center mr-1 text-gray-600 shrink-0"
            aria-label={open ? "Collapse" : "Expand"}
            title={open ? "Collapse" : "Expand"}
          >
            {open ? (
              <ChevronDown size={14} strokeWidth={2} className="text-gray-600" />
            ) : (
              <ChevronRight size={14} strokeWidth={2} className="text-gray-600" />
            )}
          </button>
        ) : (
          <span className="w-4 h-4 mr-1 shrink-0" />
        )}

        {/* <Workflow size={16} className="text-indigo-500 mr-2 shrink-0" /> */}
       {/*  {isNotation ? (
  <span className="w-4 mr-2 text-blue-500 shrink-0"></span>
) : (
  <Workflow size={16} className="text-indigo-500 mr-2 shrink-0" />
)} */}

        <div
          className="flex items-center gap-2 min-w-0 cursor-pointer"
          onClick={() => onSelect && onSelect(node)}
        >
          {/* <span className=" truncate text-gray-800">{node.text}</span> */}
          <span
  className={`truncate ${
    isNotation ? "text-blue-600" : "text-gray-800"
  }`}
>
  {node.text}
</span>
{/* 
          {node.wbsNo !== undefined && (
            <span className=" text-gray-500 whitespace-nowrap">
              ({node.wbsNo})
            </span>
          )} */}

          {/* {node.tag > 0 && (
  <span className="text-gray-500 whitespace-nowrap">
    ({node.tag})
  </span>
)}

{node.tag < 0 && (
  <span className="text-blue-500 whitespace-nowrap">
    ({Math.abs(node.tag)})
  </span>
)} */}
        </div>
      </div>

      {open && hasChildren && (
        <div>
          {node.children.map((child, index) => (
            <AccordionNode
              key={`${child.tag}-${index}`}
              node={child}
              level={level + 1}
              onSelect={onSelect}
              selectedTag={selectedTag}
              openNodes={openNodes}
  setOpenNodes={setOpenNodes}
            />
          ))}
        </div>
      )}
    </div>
  );
};

const findNodeByTag = (
  node: TreeNode,
  tag: number
): TreeNode | null => {
  if (node.tag === tag) return node;

  for (const child of node.children) {
    const found = findNodeByTag(child, tag);
    if (found) return found;
  }

  return null;
};

const SecondWBS = ({ projectId, refresh, onSelect }: Props) => {
  const [tree, setTree] = useState<TreeNode | null>(null);
  const [loading, setLoading] = useState(true);
 // const [selectedTag, setSelectedTag] = useState<number | null>(null);
 const [selectedTag, setSelectedTag] = useState<number | null>(() => {
  const saved = sessionStorage.getItem("SecondWBS_SelectedTag");
  return saved ? Number(saved) : null;
});
const [openNodes, setOpenNodes] = useState<Record<string, boolean>>({
  root: true,
});

  const loadTree = () => {
    setLoading(true);

    /* SecondWBSAPI.getTree(projectId)
      .then(setTree)
      .catch(() => alert("Failed to load tree"))
      .finally(() => setLoading(false)); */
      
      
      /* SecondWBSAPI.getTree(projectId)
  .then((data) => {
    setTree(data);

    const saved = sessionStorage.getItem("SecondWBS_SelectedTag");

    if (!saved) {
      setSelectedTag(data.tag);
      sessionStorage.setItem(
        "SecondWBS_SelectedTag",
        data.tag.toString()
      );

      onSelect?.(data);
    }
  })
  .catch(() => alert("Failed to load tree"))
  .finally(() => setLoading(false));
  }; */
  SecondWBSAPI.getTree(projectId)
  .then((data) => {
    setTree(data);

    


    /* const rootKey = getNodeKey(data);

setOpenNodes((prev) => ({
  [rootKey]: true,
  ...prev,
})); */
const rootKey = getNodeKey(data);

const savedOpenNodes = sessionStorage.getItem(
  "SecondWBSOpenNodes"
);

if (savedOpenNodes) {

  setOpenNodes({
    [rootKey]: true,
    ...JSON.parse(savedOpenNodes),
  });

} else {

  setOpenNodes({
    [rootKey]: true,
  });

}

    const saved = sessionStorage.getItem("SecondWBS_SelectedTag");

    if (saved) {
      const selectedNode = findNodeByTag(data, Number(saved));

      if (selectedNode) {
        setSelectedTag(selectedNode.tag);
        onSelect?.(selectedNode);
      } else {
        setSelectedTag(data.tag);
        sessionStorage.setItem(
          "SecondWBS_SelectedTag",
          data.tag.toString()
        );
        onSelect?.(data);
      }
    } else {
      setSelectedTag(data.tag);
      sessionStorage.setItem(
        "SecondWBS_SelectedTag",
        data.tag.toString()
      );
      onSelect?.(data);
    }
  })
  .catch(() => alert("Failed to load tree"))
  .finally(() => setLoading(false));
}


  useEffect(() => {
    loadTree();
  }, [projectId, refresh]);

 /*  useEffect(() => {

  const savedOpenNodes = sessionStorage.getItem(
    "SecondWBSOpenNodes"
  );

  if (savedOpenNodes) {

    setOpenNodes({
      root: true,
      ...JSON.parse(savedOpenNodes),
    });

  } else {

    setOpenNodes({
      root: true,
    });

  }

}, []); */

  /* const handleSelect = (node: TreeNode) => {
    setSelectedTag(node.tag);
    onSelect?.(node);
  }; */
  const handleSelect = (node: TreeNode) => {
  setSelectedTag(node.tag);

  sessionStorage.setItem(
    "SecondWBS_SelectedTag",
    node.tag.toString()
  );

  onSelect?.(node);
};

  if (loading) return <p className=" text-gray-500">Loading...</p>;

  return (
   

    <div
  className="h-full overflow-y-auto thin-scrollbar"
  style={{
    fontFamily: "'Segoe UI', sans-serif",
    fontSize: "13px",
    fontWeight: 400,
  }}
>
      {tree && (
        <AccordionNode
          node={tree}
          onSelect={handleSelect}
          selectedTag={selectedTag}
           openNodes={openNodes}
    setOpenNodes={setOpenNodes}
          
        />
      )}
    </div>
  );
};

export default SecondWBS; 
